<div class="row sub-category-default align-middle mdmax:reverse">
    <div class="col-xs-12 col-sm-8 col-md-9 is-flex content-start">
        <div class="mtr-16-32 mbr-8-24 pr-body pl-body w-100 monoproducto-slider" [ngClass]="{ 'swiper-empty': !siblingCategories?.length }">
            @if (siblingCategories?.length > 0 || filtersArray?.length > 0) {
                @defer {
                    <category-sub-categories-default-navigation
                        [siblingCategories]="siblingCategories"
                        [currentCategoryFromABTest]="currentCategoryFromABTest"
                        [showDebugCategoryIds]="showDebugCategoryIds"
                        [filtersArray]="filtersArray"
                        [isNormalBehavior]="isNormalBehavior"
                        [lastSectionTranslated]="lastSectionTranslated"
                        [direction]="direction"
                        (updateFilterEmitter)="updateFilter($event)"
                        (goToCategoryEmitter)="goToCategory($event)"
                    ></category-sub-categories-default-navigation>
                } @placeholder {
                    <div class="text-l nav-subcategory_fix_ssr"></div>
                }
            }
        </div>
    </div>

    <div class="col-xs-12 col-sm-4 col-md-3 display-filters-default">
        <div class="pr-body pl-body">
            <ng-container [ngTemplateOutlet]="selectGridView"></ng-container>
        </div>
    </div>
</div>
<div class="w-100 separator sm:hidden">
    <!--  SEPARADOR  -->
</div>
